import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import { FaFilter, FaDownload, FaEye } from "react-icons/fa";
import Navbar from '../navsidebar/navbar'
import Sidebar from '../navsidebar/sidebar'
import * as XLSX from 'xlsx';

export default function RetailDetailedReport() {

  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);

  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };


  const [activeTab, setActiveTab] = useState("order"); // Default: Order Report
  const [startDate, setStartDate] = useState(formatDate(sevenDaysAgo));
  const [endDate, setEndDate] = useState(formatDate(today));
  const [paymentMode, setPaymentMode] = useState("");
  const [data, setData] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [showDetailDialog, setShowDetailDialog] = useState(false);


  const storedData = JSON.parse(sessionStorage.getItem("userData"));

  if (storedData.business_type === 'G') {
    const businessid = sessionStorage.getItem('configBizEntityId')
    var businessEntityId = businessid;
  } else {

    var businessEntityId = storedData.businessEntityId;

    sessionStorage.setItem("configBizEntityId", businessEntityId);
  }




  const [sectionbilling, setsectionbilling] = useState("");


  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get(`retail/configuration/${businessEntityId}`);
        if (response.status === 200) {
          const config = response.data;
          setsectionbilling(config.section_billing_enabled);

        }
      } catch (error) {
        console.error("Error fetching configuration:", error);
      }
    };

    fetchConfig();
  }, [businessEntityId]);

  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSections = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`retail/sections/${businessEntityId}`);
        const data = response.data;

        setSections(data);

        // If sections exist, automatically select the first one
        if (data.length > 0) {
          setSelectedSection(data[0].id);
        }
      } catch (err) {
        setError(err.message || "Failed to fetch sections");
      } finally {
        setLoading(false);
      }
    };

    fetchSections();
  }, [businessEntityId]);

  // API URLs for each report
  const apiUrls = {
    order: `retail/getOrdersWithDiscounts/${businessEntityId}`,
    item: `retail/getSoldItemsByDate/${businessEntityId}`,
    "Customer Report": `retail/getRetailOrderscustomer/${businessEntityId}`,
    "GST Report": `retail/getRetailgstreport/${businessEntityId}`,
    "Section Report": `retail/getsectionreport/${businessEntityId}/${selectedSection}`,
    "Service Provider Report": `retail/service-providers-report/${businessEntityId}`
  };

  // Fetch data only when tab changes or filters change
  useEffect(() => {
    fetchReportData();
  }, [activeTab, selectedSection, startDate, endDate, paymentMode]);

  const fetchReportData = async () => {
    try {
      console.log('Fetching data for tab:', activeTab);
      console.log('API URL:', apiUrls[activeTab]);
      console.log('Params:', { start_date: startDate, end_date: endDate, payment_mode: paymentMode });

      const response = await axios.get(`${apiUrls[activeTab]}`, {
        params: { start_date: startDate, end_date: endDate, payment_mode: paymentMode },
      });
      console.log('Response data:', response.data);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching report:", error);
      console.error("Error details:", error.response?.data);
    }
  };


  const SectionDropdown = () => {
    if (loading) return <p className="text-muted">Loading sections...</p>;
    if (error) return <p className="text-danger">{error}</p>;
    if (!sections.length) return null;



    return (
      <select
        value={selectedSection || ""}
        onChange={(e) => setSelectedSection(Number(e.target.value))}
        className="form-select w-auto"
      >
        {sections.map((section) => (
          <option key={section.id} value={section.id}>
            {section.name}
          </option>
        ))}
      </select>
    );
  };

  const Tabs = (sectionbilling === 1) ? ["order", "item", "Customer Report", "GST Report", "Section Report", "Service Provider Report"] : ["order", "item", "Customer Report", "GST Report", "Service Provider Report"];



  const handleDownload = () => {
    // Create worksheet data based on active tab
    let worksheetData = [];

    // Add headers based on active tab
    if (activeTab === "order") {
      worksheetData.push([
        'S/N', 'Invoice Number', 'Sub Total', 'Payment Status', 'Payment Mode',
        'Via-Cash', 'Via-UPI', 'Via-Card', 'Item Discount', 'Grand Total Discount', 'Grand Total'
      ]);
    } else if (activeTab === "Customer Report") {
      worksheetData.push([
        'S/N', 'Invoice Number', 'Customer Name', 'Phone No.', 'GST Number', 'Customer Type'
      ]);
    } else if (activeTab === "GST Report") {
      worksheetData.push([
        'S/N', 'Invoice Number', 'Date', 'Payment Mode', 'Total CGST', 'Total SGST',
        'Taxable Amount', 'Grand Total'
      ]);
    } else if (activeTab === "item") {
      worksheetData.push([
        'S/N', 'Item Name', 'Total Quantity', 'Total Amount (₹)'
      ]);
    } else if (activeTab === "Section Report") {
      worksheetData.push([
        'S/N', 'Invoice Number', 'Sub Total', 'Payment Status', 'Payment Mode',
        'Via-Cash', 'Via-UPI', 'Via-Card', 'Grand Total Discount', 'Grand Total'
      ]);
    } else if (activeTab === "Service Provider Report") {
      worksheetData.push([
        'S/N', 'Service Provider Name', 'Completed Order', 'Total Commission'
      ]);
    }

    // Add data rows based on active tab
    data.forEach((item, index) => {
      if (activeTab === "order") {
        worksheetData.push([
          index + 1,
          item.invoice_number,
          item.total_amount,
          item.payment_status,
          item.payment_mode,
          item.via_cash,
          item.via_upi,
          item.via_card,
          item.total_item_discount,
          item.order_discount,
          item.grand_total
        ]);
      } else if (activeTab === "Customer Report") {
        worksheetData.push([
          index + 1,
          item.invoice_number,
          item.customer_name,
          item.phone_number,
          item.gst_number,
          item.customer_type
        ]);
      } else if (activeTab === "GST Report") {
        worksheetData.push([
          index + 1,
          item.invoice_number,
          item.created_at,
          item.payment_mode,
          item.total_cgst,
          item.total_sgst,
          item.taxable_amount,
          item.grand_total
        ]);
      } else if (activeTab === "item") {
        worksheetData.push([
          index + 1,
          item.item_name,
          item.total_quantity_sold,
          item.total_sales_amount
        ]);
      } else if (activeTab === "Section Report") {
        worksheetData.push([
          index + 1,
          item.id,
          item.total_amount,
          item.payment_status,
          item.payment_mode,
          item.via_cash,
          item.via_upi,
          item.via_card,
          item.total_discount,
          item.grand_total
        ]);
      } else if (activeTab === "Service Provider Report") {
        worksheetData.push([
          index + 1,
          item.serviceProviderName,
          item.completedOrderCount,
          item.totalCommission,
          item.totalOrderAmount
        ]);
      }
    });

    // Create workbook and add worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, activeTab);

    // Generate filename with date range
    const filename = `${activeTab}_report_${startDate}_to_${endDate}.xlsx`;

    // Save file
    XLSX.writeFile(wb, filename);
  };


  const calculateTotals = () => {
    if (data.length === 0) return null;

    switch (activeTab) {
      case "order":
        return {
          total_amount: data.reduce((sum, item) => sum + Number(item.total_amount || 0), 0),
          via_cash: data.reduce((sum, item) => sum + Number(item.via_cash || 0), 0),
          via_upi: data.reduce((sum, item) => sum + Number(item.via_upi || 0), 0),
          via_card: data.reduce((sum, item) => sum + Number(item.via_card || 0), 0),
          total_item_discount: data.reduce((sum, item) => sum + Number(item.total_item_discount || 0), 0),
          order_discount: data.reduce((sum, item) => sum + Number(item.order_discount || 0), 0),
          grand_total: data.reduce((sum, item) => sum + Number(item.grand_total || 0), 0)
        };
      case "GST Report":
        return {
          total_cgst: data.reduce((sum, item) => sum + Number(item.total_cgst || 0), 0),
          total_sgst: data.reduce((sum, item) => sum + Number(item.total_sgst || 0), 0),
          taxable_amount: data.reduce((sum, item) => sum + Number(item.taxable_amount || 0), 0),
          grand_total: data.reduce((sum, item) => sum + Number(item.grand_total || 0), 0)
        };
      case "item":
        return {
          total_quantity: data.reduce((sum, item) => sum + Number(item.total_quantity_sold || 0), 0),
          total_amount: data.reduce((sum, item) => sum + Number(item.total_sales_amount || 0), 0)
        };
      case "Section Report":
        return {
          total_amount: data.reduce((sum, item) => sum + Number(item.total_amount || 0), 0),
          via_cash: data.reduce((sum, item) => sum + Number(item.via_cash || 0), 0),
          via_upi: data.reduce((sum, item) => sum + Number(item.via_upi || 0), 0),
          via_card: data.reduce((sum, item) => sum + Number(item.via_card || 0), 0),
          total_discount: data.reduce((sum, item) => sum + Number(item.total_discount || 0), 0),
          grand_total: data.reduce((sum, item) => sum + Number(item.grand_total || 0), 0)
        };
      case "Service Provider Report":
        return {
          total_orders: data.reduce((sum, item) => sum + Number(item.completedOrderCount || 0), 0),
          total_amount: data.reduce((sum, item) => sum + Number(item.totalCommission || 0), 0),
          total_order_amount: data.reduce((sum, item) => sum + Number(item.totalOrderAmount || 0), 0)
        };
      default:
        return null;
    }
  };

  return (

    <div className="d-flex">

      <Sidebar />
      <div className="d-flex flex-column w-full ">
        <Navbar />
        <div className=" p-4 bg-light min-vh-100">
          <div className=" mx-auto bg-white p-4 md:p-6 rounded shadow-lg">

            {/* Report Tabs */}
            <div className="d-flex gap-4 mb-4">
              {Tabs.map((tab) => (
                <button
                  key={tab}
                  className={`py-2 px-4 text-lg fw-bold ${activeTab === tab ? "text-warning border-bottom  " : "text-secondary"
                    }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "order"
                    ? "Order Report"
                    : tab === "Customer Report"
                      ? "Customer Report"
                      : tab === "GST Report"
                        ? "GST Report"
                        : tab === "Section Report"
                          ? "Section Report"
                          : tab === "Service Provider Report"
                            ? "Service Provider Report"
                            : "Item Report"}


                </button>
              ))}
            </div>

            {/* Filters Section */}
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-4 mt-4">
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="form-control w-auto"
              />
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="form-control w-auto"
              />
              <select
                value={paymentMode}
                onChange={(e) => setPaymentMode(e.target.value)}
                className="form-select w-auto"
              >
                <option value="">All Payment Modes</option>
                <option value="Cash">Cash</option>
                <option value="UPI">UPI</option>
                <option value="Card">Card</option>
              </select>

              {sectionbilling === 1 ? <SectionDropdown /> : <></>}

              <div className="d-flex gap-2">
                <button
                  className="btn btn-warning d-flex align-items-center gap-2"
                  onClick={fetchReportData}
                >
                  <FaFilter /> Apply Filters
                </button>
                <button
                  className="btn btn-success d-flex align-items-center gap-2"
                  onClick={handleDownload}
                  disabled={data.length === 0}
                >
                  <FaDownload /> Download Excel
                </button>
              </div>
            </div>

            {/* Report Data Table */}
            <div className="overflow-auto mt-6" style={{ maxHeight: "500px" }}>
              <table className="table table-striped table-bordered table-hover">
                <thead className="table-dark sticky-top bg-warning">
                  <tr>
                    {activeTab === "order" && (
                      <>
                        <th className="p-2 text-nowrap">S/N</th>
                        {/* <th className="p-2 text-nowrap">Order Date</th> */}
                        <th className="p-2 text-nowrap">Invoice Number</th>
                        <th className="p-2 text-nowrap">Payment Status</th>
                        <th className="p-2 text-nowrap">Payment Mode</th>
                        <th className="p-2 text-nowrap">Via-Cash</th>
                        <th className="p-2 text-nowrap">Via-UPI</th>
                        <th className="p-2 text-nowrap">Via-Card</th>
                        <th className="p-2 text-nowrap">Item Discount</th>

                        <th className="p-2 text-nowrap">Sub Total</th>
                        <th className="p-2 text-nowrap">Grand Total Discount</th>
                        <th className="p-2 text-nowrap">Grand Total</th>
                      </>
                    )}
                    {activeTab === "Customer Report" && (
                      <>
                        <th className="p-2 text-nowrap">S/N</th>
                        <th className="p-2 text-nowrap">Invoice Number</th>
                        <th className="p-2 text-nowrap">Customer Name</th>
                        <th className="p-2 text-nowrap">Phone No.</th>
                        <th className="p-2 text-nowrap">GST Number</th>
                        <th className="p-2 text-nowrap">Customer Type</th>
                      </>
                    )}
                    {activeTab === "GST Report" && (
                      <>
                        <th className="p-2 text-nowrap">S/N</th>
                        <th className="p-2 text-nowrap">Invoice Number</th>
                        <th className="p-2 text-nowrap">Date</th>
                        <th className="p-2 text-nowrap">Payment Mode</th>
                        <th className="p-2 text-nowrap">Total CGST </th>
                        <th className="p-2 text-nowrap">Total sGST </th>
                        <th className="p-2 text-nowrap">Taxable Amount</th>
                        <th className="p-2 text-nowrap">Grand Total</th>
                      </>
                    )}
                    {activeTab === "item" && (
                      <>
                        <th className="p-2 text-nowrap">S/N</th>
                        <th className="p-2 text-nowrap">Item Name</th>
                        <th className="p-2 text-nowrap">Total Quantity</th>
                        <th className="p-2 text-nowrap">Total Amount (₹)</th>
                      </>
                    )}
                    {activeTab === "Section Report" && (
                      <>
                        <th className="p-2 text-nowrap">S/N</th>
                        {/* <th className="p-2 text-nowrap">Order Date</th> */}
                        <th className="p-2 text-nowrap">Invoice Number</th>
                        <th className="p-2 text-nowrap">Payment Status</th>
                        <th className="p-2 text-nowrap">Payment Mode</th>
                        <th className="p-2 text-nowrap">Via-Cash</th>
                        <th className="p-2 text-nowrap">Via-UPI</th>
                        <th className="p-2 text-nowrap">Via-Card</th>

                        <th className="p-2 text-nowrap">Sub Total</th>
                        {/* <th className="p-2 text-nowrap">Item Discount</th> */}
                        <th className="p-2 text-nowrap">Grand Total Discount</th>
                        <th className="p-2 text-nowrap">Grand Total</th>
                      </>
                    )}
                    {activeTab === "Service Provider Report" && (
                      <>
                        <th className="p-2 text-nowrap">S/N</th>
                        <th className="p-2 text-nowrap">Service Provider Name</th>
                        <th className="p-2 text-nowrap">Completed Order</th>
                        <th className="p-2 text-nowrap">Total Commission</th>
                        <th className="p-2 text-nowrap">Total Order Amount</th>
                        <th className="p-2 text-nowrap">Actions</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-100">
                        {activeTab === "order" && (
                          <>
                            <td className="p-2 border border-gray-300">{index + 1}</td>
                            {/* <td className="p-2 border border-gray-300">{item.order_date}</td> */}
                            <td className="p-2 border border-gray-300">{item.invoice_number}</td>

                            <td className="p-2 border border-gray-300">{item.payment_status}</td>
                            <td className="p-2 border border-gray-300">{item.payment_mode}</td>
                            <td className="p-2 border border-gray-300">{item.via_cash}</td>
                            <td className="p-2 border border-gray-300">{item.via_upi}</td>
                            <td className="p-2 border border-gray-300">{item.via_card}</td>
                            <td className="p-2 border border-gray-300">{item.total_item_discount}</td>
                            <td className="p-2 border border-gray-300">{item.total_amount}</td>
                            <td className="p-2 border border-gray-300">{item.order_discount}</td>
                            <td className="p-2 border border-gray-300">{item.grand_total}</td>
                          </>
                        )}
                        {activeTab === "Customer Report" && (
                          <>
                            <td className="p-2 border border-gray-300">{index + 1}</td>
                            <td className="p-2 border border-gray-300">{item.invoice_number}</td>
                            <td className="p-2 border border-gray-300">{item.customer_name}</td>
                            <td className="p-2 border border-gray-300">{item.phone_number}</td>
                            <td className="p-2 border border-gray-300">{item.gst_number}</td>
                            <td className="p-2 border border-gray-300">{item.customer_type}</td>
                          </>
                        )}
                        {activeTab === "GST Report" && (
                          <>
                            <td className="p-2 border border-gray-300">{index + 1}</td>
                            <td className="p-2 border border-gray-300">{item.invoice_number}</td>
                            <td className="p-2 border border-gray-300">{item.created_at}</td>
                            <td className="p-2 border border-gray-300">{item.payment_mode}</td>
                            <td className="p-2 border border-gray-300">{item.total_cgst}</td>
                            <td className="p-2 border border-gray-300">{item.total_sgst}</td>
                            <td className="p-2 border border-gray-300">{item.taxable_amount}</td>
                            <td className="p-2 border border-gray-300">{item.grand_total}</td>
                          </>
                        )}
                        {activeTab === "item" && (
                          <>
                            <td className="p-2 border border-gray-300">{index + 1}</td>
                            <td className="p-2 border border-gray-300">{item.item_name}</td>
                            <td className="p-2 border border-gray-300">{item.total_quantity_sold}</td>
                            <td className="p-2 border border-gray-300">{item.total_sales_amount}</td>
                          </>
                        )}
                        {activeTab === "Section Report" && (
                          <>
                            <td className="p-2 border border-gray-300">{index + 1}</td>
                            {/* <td className="p-2 border border-gray-300">{item.order_date}</td> */}
                            <td className="p-2 border border-gray-300">{item.invoice_number}</td>

                            <td className="p-2 border border-gray-300">{item.payment_status}</td>
                            <td className="p-2 border border-gray-300">{item.payment_mode}</td>
                            <td className="p-2 border border-gray-300">{item.via_cash}</td>
                            <td className="p-2 border border-gray-300">{item.via_upi}</td>
                            <td className="p-2 border border-gray-300">{item.via_card}</td>
                            {/* <td className="p-2 border border-gray-300">{item.total_item_discount}</td> */}
                            <td className="p-2 border border-gray-300">{item.total_amount}</td>
                            <td className="p-2 border border-gray-300">{item.total_discount}</td>
                            <td className="p-2 border border-gray-300">{item.grand_total}</td>
                          </>
                        )}
                        {activeTab === "Service Provider Report" && (
                          <>
                            <td className="p-2 border border-gray-300">{index + 1}</td>
                            <td className="p-2 border border-gray-300">{item.serviceProviderName}</td>
                            <td className="p-2 border border-gray-300">{item.completedOrderCount}</td>
                            <td className="p-2 border border-gray-300">{item.totalCommission}</td>
                            <td className="p-2 border border-gray-300">{item.totalOrderAmount}</td>
                            <td className="p-2 border border-gray-300">
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                                onClick={() => {
                                  setSelectedProvider(item);
                                  setShowDetailDialog(true);
                                }}
                              >
                                <FaEye /> View Details
                              </button>
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={
                        activeTab === "order" ? 11 :
                          activeTab === "Customer Report" ? 6 :
                            activeTab === "GST Report" ? 8 :
                              activeTab === "item" ? 4 :
                                activeTab === "Section Report" ? 10 :
                                  activeTab === "Service Provider Report" ? 5 : 6
                      } className="p-4 text-center text-muted">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {activeTab === "order" && data.length > 0 && (
                <>
                  <div className="d-flex justify-content-end w-full mt-2">
                    <h4 className="text-end me-2">Total Discount:</h4>
                    <h4 className="text-end me-4">{calculateTotals().order_discount?.toFixed(2)}</h4>
                    <h4 className="text-end me-2">Sub Total:</h4>
                    <h4 className="text-end me-4">{calculateTotals().total_amount?.toFixed(2)}</h4>
                    <h4 className="text-end me-2">Grand Total:</h4>
                    <h4 className="text-end">{calculateTotals().grand_total?.toFixed(2)}</h4>
                  </div>
                </>
              )}

              {activeTab === "GST Report" && data.length > 0 && (
                <div className="d-flex justify-content-end w-full mt-2">
                  <h4 className="text-end me-2">Grand Total:</h4>
                  <h4 className="text-end">{calculateTotals().grand_total?.toFixed(2)}</h4>
                </div>
              )}

              {activeTab === "Section Report" && data.length > 0 && (
                <div className="d-flex justify-content-end w-full mt-2">
                  <h4 className="text-end me-2">Grand Total:</h4>
                  <h4 className="text-end">{calculateTotals().grand_total?.toFixed(2)}</h4>
                </div>
              )}

              {activeTab === "Service Provider Report" && data.length > 0 && (
                <>
                  <div className="d-flex justify-content-end w-full mt-2">
                    <h5 className="text-end me-2">Total Orders:</h5>
                    <h5 className="text-end me-4">{calculateTotals().total_orders}</h5>
                    <h5 className="text-end me-2">Total Commission Amount:</h5>
                    <h5 className="text-end me-4">{calculateTotals().total_amount?.toFixed(2)}</h5>
                    <h5 className="text-end me-2">Total Order Amount:</h5>
                    <h5 className="text-end me-4">{calculateTotals().total_order_amount?.toFixed(2)}</h5>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {/* Service Provider Detail Dialog */}
      {showDetailDialog && selectedProvider && (
        <>
          <div className="modal fade show"></div>

          <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 4000 }}>
            <div className="modal-dialog modal-xl modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg">

                {/* Header */}
                <div className="modal-header px-4 py-3">
                  <h5 className="modal-title fw-bold">
                    Service Provider Details – {selectedProvider.serviceProviderName}
                  </h5>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDetailDialog(false)}
                    style={{
                      width: "32px",
                      height: "32px",
                      fontSize: "16px",
                      opacity: "0.75",
                      transition: "opacity 0.2s",
                    }}
                  />
                </div>

                {/* Body */}
                <div className="modal-body px-4 py-3">

                  {/* Top Summary */}
                  <div className="row g-3 mb-4">
                    

                    <div className="col-md-4">
                      <div className="border rounded p-3 bg-light">
                        <div className="text-muted small">Completed Orders</div>
                        <div className="fw-bold">{selectedProvider.completedOrderCount}</div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="border rounded p-3 bg-light">
                        <div className="text-muted small">Total Commission</div>
                        <div className="fw-bold">₹ {selectedProvider.totalCommission}</div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="border rounded p-3 bg-light">
                        <div className="text-muted small">Total Order Amount</div>
                        <div className="fw-bold">₹ {selectedProvider.totalOrderAmount}</div>
                      </div>
                    </div>
                  </div>

                  {/* Items Table */}
                  <h6 className="fw-bold mb-3">Items Details</h6>

                  <div className="table-responsive">
                    <table className="table table-hover align-middle">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "70px" }}>S/N</th>
                          <th>Item Name</th>
                          <th style={{ width: "120px" }}>Quantity</th>
                          <th style={{ width: "150px" }}>Commission (₹)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {selectedProvider.items && selectedProvider.items.length > 0 ? (
                          selectedProvider.items.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.item_name}</td>
                              <td>{item.qty}</td>
                              <td>₹ {item.commission}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center text-muted py-4">
                              No items found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Bottom Total */}
                  {selectedProvider.items && selectedProvider.items.length > 0 && (
                    <div className="text-end mt-3">
                      <span className="me-2 fw-semibold">Total Items Commission:</span>
                      <span className="fw-bold">
                        ₹{" "}
                        {selectedProvider.items
                          .reduce((sum, item) => sum + Number(item.commission || 0), 0)
                          .toFixed(2)}
                      </span>
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div className="modal-footer px-4 py-3">
                  <button
                    type="button"
                    className="btn btn-warning px-4"
                    onClick={() => setShowDetailDialog(false)}
                  >
                    Close
                  </button>
                </div>

              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}